import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Divider,
  Grid,
} from "@mui/material";

const InvoiceChargesDetails = ({ charges }) => {
  if (!charges || charges.length === 0) {
    return <Typography>No charges available.</Typography>;
  }

  const charge = charges[0]; // since only 1 for now

  return (
    <Box sx={{ maxWidth: 900, mx: "auto", mt: 4 }}>
      <Card sx={{ p: 2, boxShadow: 3, borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Invoice Charges Details
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Grid container spacing={2}>
            {/* Basic Info */}
    
            <Grid item xs={12} sm={6}>
              <Typography><strong>Currency:</strong> {charge?.currency}</Typography>
            </Grid>


            {/* Fees */}
            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
              <Typography variant="h6">Manning Fee (New Joiner)</Typography>
              <Typography>Senior Officer: {charge?.manningFeeForNewJoiner?.seniorOfficer}</Typography>
              <Typography>Junior Officer: {charge?.manningFeeForNewJoiner?.juniorOfficer}</Typography>
              <Typography>Rating: {charge?.manningFeeForNewJoiner?.rating}</Typography>
            </Grid>

            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
              <Typography variant="h6">Manning Fee (Rejoiner)</Typography>
              <Typography>Senior Officer: {charge?.manningFeeForRejoiner?.seniorOfficer}</Typography>
              <Typography>Junior Officer: {charge?.manningFeeForRejoiner?.juniorOfficer}</Typography>
              <Typography>Rating: {charge?.manningFeeForRejoiner?.rating}</Typography>
            </Grid>

            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
              <Typography variant="h6">Manning Fee (Owner Proposed)</Typography>
              <Typography>Senior Officer: {charge?.manningFeeForOwnerProposed?.seniorOfficer}</Typography>
              <Typography>Junior Officer: {charge?.manningFeeForOwnerProposed?.juniorOfficer}</Typography>
              <Typography>Rating: {charge?.manningFeeForOwnerProposed?.rating}</Typography>
            </Grid>

            {/* Other Charges */}
            <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
              <Typography variant="h6">Other Charges</Typography>
              <Typography>One-Time Finder’s Fee: {charge?.oneTimeFindesFee}</Typography>
              <Typography>
                Crew Welfare: {charge?.crewWelfare?.amount} ({charge?.crewWelfare?.perDayOrPerMonth})
              </Typography>
              <Typography>
                Retention Fee: {charge?.retentionFee?.amount} ({charge?.retentionFee?.perDayOrPerMonth})
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default InvoiceChargesDetails;
